<div id="modalWrapper" [ngClass]="{'hidden': hidden}">
	<div class="modal-header">
		<h5 class="modal-title">{{title}}</h5>
		<div class="fCenter">
			<div class="fCenter margin">
				<p>Verberg namen <i class="fa-solid fa-user-slash"></i></p>
				<label class="switch">
					<input type="checkbox" [(ngModel)]="hideNames">
					<span class="slider round"></span>
				</label>
			</div>
			<div class="fCenter margin">
				<p>Verberg antwoordvoorbeeld <i class="fa-solid fa-eye-slash"></i></p>
				<label class="switch">
					<input type="checkbox" [(ngModel)]="hideAnswers">
					<span class="slider round"></span>
				</label>
			</div>
			<div id="buttons">
				<button type="button" class="close" aria-label="Close" (click)="close()">
					<i class="fa-solid fa-xmark"></i>
				</button>
				<button type="button" class="close" aria-label="Close" (click)="backToOverview(true)">
					<i class="fa-solid fa-arrow-left"></i>
				</button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<table>
			<tr>
				<th></th>
				<th class="clickable" (click)="showQuestionOverview(question['questionId'])"
					*ngFor="let question of getFilteredQuestions(); let i = index; last as isLast; first as isFirst;"
					[ngClass]="{'truncate' : question['questionId'] != questionId}">
					<p>{{question['questionLetter']}}</p>
					<p class="helvetica" [innerHTML]="question['questionTitle']"></p>
					<p class="questionAnswer helvetica" [ngClass]="{'blur' : hideAnswers || question['questionId'] != questionId}">{{question['teacherAnswer']}}
					</p>
					<i class="fa-solid fa-chevron-right" id="toRightBottom"
						*ngIf="isLast && isNotLastQuestion(question['questionId'])"></i>
					<i class="fa-solid fa-chevron-left" *ngIf="isFirst && isNotFirstQuestion(question['questionId'])"
						id="toLeftBottom"></i>
				</th>
			</tr>
			<tr *ngFor="let student of answerData.students; let i = index">
				<td [ngClass]="{'blur' : hideNames}" [ngClass]="{'isEmail' : isEmailValid(student['studentName'])}" class="studentName clickable"
					(click)="openStudentOverview(student)">
					<i class="fa-solid fa-square-arrow-up-right"></i>
					{{student['studentName']}} <span
						*ngIf="classroomDetails.defaultStudyLevel != student['studentStudyLevel']">({{student['studentStudyLevel']}})</span>
				</td>
				<td colspan="999">
					<div>{{student['answerValue']}}</div>
					<div class="statusButtons" *ngIf="student.answerValue">
						<button (click)="updateAnswerState('perfect', student['answerId'], student['studentId'])"
							[ngClass]="student['answerStatus'] == 'PERFECT' ? 'sel-perfect' : ''"
							class="btn btn-sm answer-button btn-success"
							[attr.data-question-id]="'qna-' + i + '-question'">Goed!</button>
						<button (click)="updateAnswerState('correct', student['answerId'], student['studentId'])"
							[ngClass]="student['answerStatus'] == 'CORRECT' ? 'sel-correct' : ''"
							class="btn btn-sm answer-button btn-warning"
							[attr.data-question-id]="'qna-' + i + '-question'">Voldoende</button>
						<button (click)="updateAnswerState('wrong', student['answerId'], student['studentId'])"
							[ngClass]="student['answerStatus'] == 'WRONG' ? 'sel-wrong' : ''"
							class="btn btn-sm answer-button btn-danger"
							[attr.data-question-id]="'qna-' + i + '-question'">Onvoldoende</button>
					</div>
				</td>
			</tr>
		</table>
	</div>
</div>